export default __webpack_public_path__ + "static/media/img_block_4.e6d6d85a.svg";